export const profileLinks = [
  {
    icon: 'ni ni-single-02',
    name: 'components.layout.navbars.profileDropdown.my_profile',
    id: 'my-profile-btn',
    href: '/profile'
  },
];
